import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { AgencyPerfermanceOverviewReportFormModel, GroupedByEnum } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): AgencyPerfermanceOverviewReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  room_type_ids: [],
  market_code_ids: [],
  segment_market_code_ids: [],
  cards: [],
  grouped_by: GroupedByEnum.NONE,
  gross_revenue: false,
  with_revenue: false,
  currency: null,
  currency_application: null,
  fixed_at: '',
  file_type: 'pdf',
});
